import React from "react";
import PropTypes from "prop-types";
import { MasterSidebar } from "../../../../components/Common";
import { formatCurrency } from "../../../../utils/format";

/**
 * ServiceSidebar
 * Lista de Produtos e Serviços utilizando o componente padronizado MasterSidebar.
 */
const ServiceSidebar = ({ items, activeId, onSelect, onCreateNew, loading, onReorder }) => {

    const renderServiceItem = (item, isActive) => (
        <div className="text-start w-100 overflow-hidden">
            <div className="d-flex align-items-center justify-content-between">
                <p className={`mb-0 fw-semibold text-truncate ${isActive ? 'text-primary' : 'text-dark'}`} style={{ fontSize: '13.5px' }}>
                    {item.nameService || "Sem Nome"}
                </p>
                {item.inactive && (
                    <i className="mdi mdi-eye-off-outline text-muted" style={{ fontSize: '14px' }} title="Inativo"></i>
                )}
            </div>
            <span className="text-muted small text-truncate d-block mt-1" style={{ fontSize: '11px', opacity: 0.8 }}>
                {item.type === 'product' ? 'Produto' : 'Serviço'} • {formatCurrency(item.value)}
            </span>
        </div>
    );

    return (
        <MasterSidebar
            title="Produtos e Serviços"
            subtitle="Itens disponíveis para venda"
            items={items}
            activeId={activeId}
            onSelect={onSelect}
            onCreateNew={onCreateNew}
            loading={loading}
            searchPlaceholder="Buscar produto ou serviço..."
            icon="mdi mdi-package-variant-closed"
            renderItem={renderServiceItem}
            onReorder={onReorder}
            loadingMessage="Carregando produtos e serviços..."
        />
    );
};

ServiceSidebar.propTypes = {
    items: PropTypes.array,
    activeId: PropTypes.string,
    onSelect: PropTypes.func,
    onCreateNew: PropTypes.func,
    loading: PropTypes.bool,
    onReorder: PropTypes.func
};

export default ServiceSidebar;
